import { Model, Attr, HasOne } from 'spraypaint';
import ApplicationRecord from './ApplicationRecord';
import { ShortTermDay, Lot } from './';

@Model()
export default class ShortTermRate extends ApplicationRecord {
  static jsonapiType = 'short-term-rates';

  static listHeaders() {
    return [
      {
        text: 'ID',
        value: 'id',
        width: 100,
        sortable: false,
      },
      {
        text: 'Rate',
        value: 'rate',
      },
    ];
  }

  static scopeFactory() {
    return ShortTermRate.includes([]);
  }

  @Attr() rate: string | null;

  @HasOne() shortTermDay: ShortTermDay;
  @HasOne() lot: Lot;

  get formattedRate() {
    return new Intl.NumberFormat('en-AU', {
      style: 'currency',
      currency: 'AUD',
    }).format(Number(this.rate));
  }
}
